module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAARCAYAAABgpdrLAAAAhElEQVRYhe2X0QqAIAxFW/T/v1z5MJDa3YxCm9zzJNw9uIMylf1kITfW0Rv4KxQDoBgAxQBSixGRMPdqvHx7tbNBREK0RgduvW7NU56Y0oT3yrg2Wta1zCgvpBTTA4oBUAyAYgAUA5hSzNMpZI7zjL9r6x1jtaF1qEUvTymmB1NepS84AJ42PyJIpqTEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qhtb1-2.png
// module id = 705
// module chunks = 0